// import { Button, Select } from "antd";
import React, { useEffect } from "react";
import { Select, Collapse, Input, Button, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_CRM_URL } from "../../../components/config/config";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import { Currency } from "lucide-react";
// import * as bootstrap from "bootstrap";
// import { useRef } from "react";

const NewCustomer = ({
  getCustomers,
  onClose,
  show,
  leadData,
  isConvert = false,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/singinThree");
    }
  }, [navigate]);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const staffId = userDetails.staffid;

  const [activeTab, setActiveTab] = useState(0);
  // const [showGroupAccordion, setShowGroupAccordion] = useState(false);
  // const [groupName, setGroupName] = useState("");
  const [showGroupAccordion, setShowGroupAccordion] = useState(false);
  const [activeKey, setActiveKey] = useState([]);

  //Add new group integration part
  const [groupName, setGroupName] = useState("");
  const [groupLoading, setGroupLoading] = useState(false);

  const addCustomerGroup = async () => {
    if (!groupName.trim()) {
      Swal({
        title: "Warning",
        text: "Please enter group name.",
        icon: "warning",
        button: "OK",
      });
      return;
    }

    setGroupLoading(true);

    try {
      const payload = {
        Name: groupName,
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}customers/AddCustomerGroup`,
        payload,
      );

      console.log("Response:", response.data);

      if (response.data.Status) {
        Swal.fire({
          title: "Success",
          text: response.data.Message,
          icon: "success",
          confirmButtonText: "OK",
        });

        // Reset form
        setGroupName("");

        // Hide accordion
        setShowGroupAccordion(false);

        // Refresh group dropdown
        getCustomerGroups();
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "Unable to add customer group.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Add Customer Group Error:", error);
    } finally {
      setGroupLoading(false);
    }
  };

  //get groups drop down and country  integration
  const [groupOptions, setGroupOptions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);

  const [currency, setCurrency] = useState([]);
  const [currencyLoading, setCurrencyLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [sameAsBilling, setSameAsBilling] = useState(false);

  const getCustomerGroups = async () => {
    try {
      const response = await axios.get(`${BASE_CRM_URL}customers/GetGroups`);

      if (response.data.Status) {
        setGroupOptions(
          response.data.ResultData.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getCountries = async () => {
    setCountryLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}GetCountries`);

      if (response.data.Status) {
        setCountries(response.data.ResultData || []);
      }
    } catch (error) {
      console.error("Country API Error:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getCurrency = async () => {
    setCurrencyLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}GetCurrencies`);

      if (response.data.Status) {
        setCurrency(response.data.Data || []);
      }
    } catch (error) {
      console.error("Currency API Error:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  useEffect(() => {
    getCustomerGroups();
    getCountries();
    getCurrency();
  }, []);

  const countryOptions = countries.map((country) => ({
    value: country.country_id,
    label: country.short_name,
  }));

  const currencyOptions = currency.map((currency) => ({
    value: currency.id,
    label: currency.symbol + " " + currency.name,
  }));

  //Add integration
  const [formData, setFormData] = useState({
    company: "",
    gsin: "", // Will be mapped to "vat" in payload
    groups: [],
    default_currency: null,
    default_language: "English",

    phonenumber: "",
    country: null,
    city: "",
    state: "",
    zip: "",
    address: "",
    website: "",

    leadid: 0,
    addedfrom: "",
    active: 1,

    // Custom Fields
    clientname: "",
    clientid: "",
    renewaldate: "",
    amcamount: "",
    lastpayment: "",
    countstaff: "",
    location: "",
    subscription: "",

    // Billing
    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_country: null,

    // Shipping
    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_country: null,

    // Optional API fields
    longitude: "",
    latitude: "",
    show_primary_contact: 1,
    stripe_id: "",
    registration_confirmed: 1,
    googlelocation: "",
    head_office_flag: 0,
  });

  useEffect(() => {
    if (show && isConvert && leadData) {
      setFormData((prev) => ({
        ...prev,

        company: leadData.company || "",
        clientname: leadData.name || "",

        phonenumber: leadData.phonenumber || "",
        country: leadData.country || "",
        city: leadData.city || "",
        state: leadData.state || "",
        zip: leadData.zip || "",
        address: leadData.address || "",
        website: leadData.website || "",

        leadid: leadData.id || 0,
        addedfrom: leadData.addedfrom || "",
        active: leadData.active ?? 1,

        default_language: leadData.default_language || "english",

        gsin: leadData.vat || "",

        billing_street: leadData.address || "",
        billing_city: leadData.city || "",
        billing_state: leadData.state || "",
        billing_zip: leadData.zip || "",
        billing_country: leadData.country || "",

        shipping_street: leadData.address || "",
        shipping_city: leadData.city || "",
        shipping_state: leadData.state || "",
        shipping_zip: leadData.zip || "",
        shipping_country: leadData.country || "",
      }));
    }
  }, [show, isConvert, leadData]);

  const initialData = {
    company: "",
    gsin: "",
    groups: [],
    default_currency: 5,
    default_language: "english",
    phonenumber: "",
    country: "",
    city: "",
    state: "",
    zip: "",
    address: "",
    website: "",
    leadid: 0,
    addedfrom: "",
    active: 1,

    // Billing
    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_country: "",

    // Shipping
    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_country: "",

    // Optional API fields
    longitude: "",
    latitude: "",
    show_primary_contact: 1,
    stripe_id: "",
    registration_confirmed: 1,
    googlelocation: "",
    head_office_flag: 0,

    // Custom Fields
    clientname: "",
    clientid: "",
    renewaldate: "",
    amcamount: "",
    lastpayment: "",
    countstaff: "",
    location: "",
    subscription: "",
  };

  const handleNext = () => {
    if (activeTab < 2) {
      setActiveTab((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (activeTab > 0) {
      setActiveTab((prev) => prev - 1);
    }
  };

  const addCustomer = async () => {
    const payload = {
      company: formData.company,
      vat: formData.gsin,
      phonenumber: formData.phonenumber,
      country: formData.country,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      address: formData.address,
      website: formData.website,
      active: formData.active,
      leadid: formData.leadid,
      addedfrom: staffId,
      groups: formData.groups,

      billing_street: formData.billing_street,
      billing_city: formData.billing_city,
      billing_state: formData.billing_state,
      billing_zip: formData.billing_zip,
      billing_country: formData.billing_country,

      shipping_street: formData.shipping_street,
      shipping_city: formData.shipping_city,
      shipping_state: formData.shipping_state,
      shipping_zip: formData.shipping_zip,
      shipping_country: formData.shipping_country,

      longitude: formData.longitude || "",
      latitude: formData.latitude || "",
      default_language: formData.default_language,
      default_currency: formData.default_currency,

      stripe_id: "",
      registration_confirmed: 1,
      // googlelocation: "",
      // head_office_flag: 0,

      customFields: [
        {
          fieldId: 4,
          value: formData.clientid,
        },
        {
          fieldId: 5,
          value: formData.clientname,
        },
        {
          fieldId: 6,
          value: formData.renewaldate,
        },

        {
          fieldId: 7,
          value: formData.amcamount,
        },
        {
          fieldId: 15,
          value: formData.lastpayment,
        },
        {
          fieldId: 9,
          value: formData.countstaff,
        },
        {
          fieldId: 10,
          value: formData.location,
        },
        {
          fieldId: 16,
          value: formData.subscription,
        },
      ],
    };

    console.log("Payload:", payload);
    console.log("Groups:", payload.groups);
    console.log(Array.isArray(payload.groups));

    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_CRM_URL}customers/AddWebCustomer`,
        payload,
      );

      console.log("Response:", response.data);

      if (response.data.Status) {
        await Swal.fire({
          title: "Success",
          text: response.data.message || "Customer added successfully.",
          icon: "success",
          button: "OK",
        });

        await getCustomers();
        onClose();

        // Reset form
        setFormData(initialData);

        // Refresh customer list
        // getCustomers();

        // Close modal/offcanvas if required
        // onClose();
      } else {
        Swal.fire({
          title: "Warning",
          text: response.data.message || "Unable to add customer.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Add Customer Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setFormData(initialData);

    onClose();
    setActiveTab(0);
  };
  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightNewCustomer");

    const handleOffcanvasClose = () => {
      setFormData(initialData);
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose,
        );
      }
    };
  }, []);

  // useEffect(() => {
  //   const offcanvasElement = document.getElementById("offcanvasRightNewCustomer");

  //   if (!offcanvasElement) return;

  //   const bsOffcanvas =
  //     bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);

  //   if (show) {
  //     bsOffcanvas.show();
  //   } else {
  //     bsOffcanvas.hide();
  //   }
  // }, [show]);

  // const offcanvasRef = useRef(null);

  // useEffect(() => {
  //   const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(
  //     offcanvasRef.current
  //   );

  //   if (show) {
  //     bsOffcanvas.show();
  //   } else {
  //     bsOffcanvas.hide();
  //   }
  // }, [show]);

  return (
    <>
      {show && (
        <div>
          {loading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}
          <style>
            {`
    @media (max-width: 576px) {
      #offcanvasRightNewCustomer {
        width: 90% !important;
      }
    }

    @media (min-width: 577px) and (max-width: 992px) {
      #offcanvasRightNewCustomer {
        width: 60% !important;
      }
    }

    @media (min-width: 993px) and (max-width: 1440px) {
      #offcanvasRightNewCustomer {
        width: 45% !important;
      }
    }

    @media (min-width: 1441px) and (max-width: 1920px) {
      #offcanvasRightNewCustomer {
        width: 30% !important;
      }
    }

    /* 2K / 4K and larger screens */
    @media (min-width: 1921px) {
      #offcanvasRightNewCustomer {
        width: 28% !important;
      }
    }
  `}
          </style>

          <div className="offcanvas-backdrop fade show" onClick={onClose} />

          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightNewCustomer"
            style={{ visibility: "visible" }}
            // tabIndex="-1"
            // aria-labelledby="offcanvasRightLabel"
          >
            <div className="offcanvas-header d-flex justify-content-between align-items-center">
              <h4 id="offcanvasRightLabel">
                {activeTab === 0
                  ? "Add New Customer"
                  : activeTab === 1
                    ? "Additional Details"
                    : "Address"}
              </h4>

              <div className="d-flex align-items-center gap-2 ms-auto">
                {/* Close */}
                <button
                  type="button"
                  onClick={handleClose}
                  disabled={loading}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#e40d22",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Close"
                >
                  <i className="fa fa-times" />
                </button>

                {/* Back button - only show on tabs 1 and 2 */}
                {activeTab > 0 && (
                  <button
                    type="button"
                    onClick={handlePrevious}
                    disabled={loading}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#6c757d",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Previous"
                  >
                    <i className="fa fa-arrow-left" />
                  </button>
                )}

                {/* Next / Save */}
                {activeTab < 2 ? (
                  <button
                    type="button"
                    onClick={handleNext}
                    disabled={loading}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#0d6efd",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Next"
                  >
                    <i className="fa fa-arrow-right" />
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={addCustomer}
                    disabled={loading}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#07f083",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Save"
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      <i className="fa fa-check" />
                    )}
                  </button>
                )}
              </div>
            </div>
            <hr className="m-0" />
            <div className="offcanvas-body">
              <ul
                className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                id="myTab1"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  {/* <button
                  className="nav-link active"
                  id="item-details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#item-details-pane"
                  type="button"
                  role="tab"
                  aria-controls="item-details-pane"
                  aria-selected="true"
                >
                  Customer Details
                </button> */}
                  <button
                    className={`nav-link ${activeTab === 0 ? "active" : ""}`}
                    onClick={() => setActiveTab(0)}
                  >
                    Customer Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  {/* <button
                  className="nav-link"
                  id="store-location-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#store-location-pane"
                  type="button"
                  role="tab"
                  aria-controls="store-location-pane"
                  aria-selected="false"
                >
                  Custom Fields
                </button> */}
                  <button
                    className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                    onClick={() => setActiveTab(1)}
                  >
                    Additional Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  {/* <button
                  className="nav-link"
                  id="done-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#done-pane"
                  type="button"
                  role="tab"
                  aria-controls="done-pane"
                  aria-selected="false"
                >
                  Billing & Shipping
                </button> */}
                  <button
                    className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                    onClick={() => setActiveTab(2)}
                  >
                    Billing & Shipping
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  // className="tab-pane fade show active text-muted"
                  // id="item-details-pane"
                  // role="tabpanel"
                  // aria-labelledby="item-details-tab"
                  // tabIndex={0}
                  className={
                    activeTab === 0
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                >
                  <>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          Company <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Company Name"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">GSTIN</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GSTIN"
                          name="gsin"
                          value={formData.gsin}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          name="phonenumber"
                          value={formData.phonenumber}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Website</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Website URL"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <label className="form-label">Currency</label>
                        <Select
                          placeholder="Select Currency"
                          options={currencyOptions}
                          style={{ width: "100%", height: 38 }}
                          value={formData.default_currency}
                          onChange={(value) =>
                            setFormData((prev) => ({
                              ...prev,
                              default_currency: value,
                            }))
                          }
                          loading={currencyLoading}
                          showSearch
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        ></Select>
                      </div>

                      <div className="col-12 mb-3">
                        <label className="form-label">Groups</label>

                        <div className="d-flex align-items-center">
                          <Select
                            className="flex-grow-1"
                            mode="multiple"
                            style={{ width: "100%", height: 38 }}
                            placeholder="Select Group"
                            options={groupOptions}
                            allowClear
                            value={formData.groups}
                            onChange={(values) =>
                              setFormData((prev) => ({
                                ...prev,
                                groups: values,
                              }))
                            }
                          />

                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            className="ms-2"
                            onClick={() => {
                              setShowGroupAccordion((prev) => !prev);
                              setActiveKey((prev) =>
                                prev.length ? [] : ["1"],
                              );
                            }}
                          />
                        </div>
                      </div>
                      {showGroupAccordion && (
                        <Collapse
                          activeKey={activeKey}
                          onChange={(keys) => setActiveKey(keys)}
                          items={[
                            {
                              key: "1",
                              label: "Add New Customer Group",
                              children: (
                                <>
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Group Name
                                    </label>
                                    <Input
                                      placeholder="Enter Group Name"
                                      value={groupName}
                                      onChange={(e) =>
                                        setGroupName(e.target.value)
                                      }
                                    />
                                  </div>

                                  <div className="text-end">
                                    <Button
                                      className="me-2"
                                      onClick={() => {
                                        setGroupName("");
                                        setActiveKey([]);
                                        setShowGroupAccordion(false);
                                      }}
                                    >
                                      Close
                                    </Button>

                                    <Button
                                      type="primary"
                                      loading={groupLoading}
                                      onClick={addCustomerGroup}
                                    >
                                      Save
                                    </Button>
                                  </div>
                                </>
                              ),
                            },
                          ]}
                        />
                      )}

                      {/* <div className="col-6 mb-3 mt-2">
                      <label className="form-label">Default Language</label>
                      <select className="form-control">
                        <option>System Default</option>
                      </select>
                    </div> */}

                      <div className="col-12 mb-3">
                        <label className="form-label">Address</label>
                        <textarea
                          className="form-control"
                          rows={2}
                          placeholder="Enter Address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter State"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Zip Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Zip Code"
                          name="zip"
                          value={formData.zip}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Country</label>
                        <Select
                          placeholder="Select Country"
                          options={countryOptions}
                          style={{ width: "100%", height: 38 }}
                          value={formData.country}
                          onChange={(value) =>
                            setFormData((prev) => ({
                              ...prev,
                              country: value,
                            }))
                          }
                          loading={countryLoading}
                          showSearch
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </div>

                      {/* <div className="d-flex justify-content-end gap-3 mt-4">
                        <button
                          className="btn btn-danger"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={() => setActiveTab(1)}
                        >
                          Next
                        </button>
                      </div> */}
                    </div>
                  </>
                </div>

                <div
                  // className="tab-pane fade text-muted"
                  // id="store-location-pane"
                  // role="tabpanel"
                  // aria-labelledby="store-location-tab"
                  // tabIndex={0}
                  className={
                    activeTab === 1
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                >
                  <form>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <label className="form-label">Client Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Client Name"
                          name="clientname"
                          value={formData.clientname}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Client ID</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Client ID"
                          name="clientid"
                          value={formData.clientid}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">Renewal Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="renewaldate"
                          value={formData.renewaldate}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <label className="form-label">AMC Amount</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter AMC Amount"
                          name="amcamount"
                          value={formData.amcamount}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <label className="form-label">Last Payment</label>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Enter LastPayment"
                          name="lastpayment"
                          value={formData.lastpayment}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <label className="form-label">
                          CountStaff/Terminals
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter countstaff"
                          name="countstaff"
                          value={formData.countstaff}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <label className="form-label">Location</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Location"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <label className="form-label d-block">
                          Subscription
                        </label>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="subscription"
                            value={1}
                            checked={formData.subscription === 1}
                            //  checked={getCustomFieldValue(8) === "1"}
                            onChange={handleChange}
                          ></input>
                          <label className="form-check-label">yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="subscription"
                            value={0}
                            checked={formData.subscription === 0}
                            //  checked={getCustomFieldValue(8) === "0"}
                            onChange={handleChange}
                          ></input>
                          <label className="form-check-label">No</label>
                        </div>
                      </div>
                    </div>

                    {/* <div className="d-flex justify-content-end gap-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setActiveTab(0)}
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => setActiveTab(2)}
                      >
                        Next
                      </button>
                    </div> */}
                  </form>
                </div>

                <div
                  // className="tab-pane fade text-muted"
                  // id="done-pane"
                  // role="tabpanel"
                  // aria-labelledby="done-tab"
                  // tabIndex={0}
                  className={
                    activeTab === 2
                      ? "tab-pane fade show active"
                      : "tab-pane fade"
                  }
                >
                  <form>
                    <div className="row">
                      {/* Billing Address */}
                      <div className="col-6">
                        <label className="form-label">Billing </label>

                        <textarea
                          className="form-control mb-3"
                          placeholder="Street"
                          name="billing_street"
                          value={formData.billing_street}
                          onChange={handleChange}
                        />

                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="City"
                          name="billing_city"
                          value={formData.billing_city}
                          onChange={handleChange}
                        />

                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="State"
                          name="billing_state"
                          value={formData.billing_state}
                          onChange={handleChange}
                        />

                        <label className="form-label">Zip Code</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Zip Code"
                          name="billing_zip"
                          value={formData.billing_zip}
                          onChange={handleChange}
                        />

                        <div className="mb-3">
                          <label className="form-label">Country</label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            placeholder="Select Country"
                            options={countryOptions}
                            value={formData.billing_country}
                            onChange={(value) =>
                              setFormData((prev) => ({
                                ...prev,
                                billing_country: value,
                              }))
                            }
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>
                      {/* Shipping Address */}
                      {/* <div className="col-6">
                        <label className="form-label">Shipping Address</label>

                        <textarea
                          className="form-control mb-3"
                          placeholder="Street"
                          name="shipping_street"
                          value={formData.shipping_street}
                          onChange={handleChange}
                        />

                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="City"
                          name="shipping_city"
                          value={formData.shipping_city}
                          onChange={handleChange}
                        />

                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="State"
                          name="shipping_state"
                          value={formData.shipping_state}
                          onChange={handleChange}
                        />

                        <label className="form-label">Zip Code</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Zip Code"
                          name="shipping_zip"
                          value={formData.shipping_zip}
                          onChange={handleChange}
                        />

                        <div className="mb-3">
                          <label className="form-label d-block">Country</label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            placeholder="Select Country"
                            options={countryOptions}
                            value={formData.shipping_country}
                            onChange={(value) =>
                              setFormData((prev) => ({
                                ...prev,
                                shipping_country: value,
                              }))
                            }
                          />
                        </div>
                      </div> */}
                      {/* Shipping Address */}
                      <div className="col-6">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <label className="form-label mb-0">Shipping</label>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="sameAsBilling"
                              checked={sameAsBilling}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSameAsBilling(checked);

                                if (checked) {
                                  setFormData((prev) => ({
                                    ...prev,
                                    shipping_street: prev.billing_street,
                                    shipping_city: prev.billing_city,
                                    shipping_state: prev.billing_state,
                                    shipping_zip: prev.billing_zip,
                                    shipping_country: prev.billing_country,
                                  }));
                                } else {
                                  setFormData((prev) => ({
                                    ...prev,
                                    shipping_street: "",
                                    shipping_city: "",
                                    shipping_state: "",
                                    shipping_zip: "",
                                    shipping_country: "",
                                  }));
                                }
                              }}
                            />

                            <label
                              className="form-check-label"
                              htmlFor="sameAsBilling"
                            >
                              Same Billing Address
                            </label>
                          </div>
                        </div>

                        <textarea
                          className="form-control mb-3"
                          placeholder="Street"
                          name="shipping_street"
                          value={formData.shipping_street}
                          onChange={handleChange}
                        />

                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="City"
                          name="shipping_city"
                          value={formData.shipping_city}
                          onChange={handleChange}
                        />

                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="State"
                          name="shipping_state"
                          value={formData.shipping_state}
                          onChange={handleChange}
                        />

                        <label className="form-label">Zip Code</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Zip Code"
                          name="shipping_zip"
                          value={formData.shipping_zip}
                          onChange={handleChange}
                        />

                        <div className="mb-3">
                          <label className="form-label d-block">Country</label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            placeholder="Select Country"
                            options={countryOptions}
                            value={formData.shipping_country}
                            onChange={(value) =>
                              setFormData((prev) => ({
                                ...prev,
                                shipping_country: value,
                              }))
                            }
                            showSearch
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="d-flex justify-content-end gap-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setActiveTab(1)}
                      >
                        Previous
                      </button>

                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={addCustomer}
                      >
                        Save
                      </button>
                      <button type="button" className="btn btn-warning">
                        Save & create contact
                      </button>
                    </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
NewCustomer.propTypes = {
  getCustomers: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  leadData: PropTypes.object,
  isConvert: PropTypes.bool,
};

export default NewCustomer;
